<template>
  <div>
    <h1>Playlist Ceremonies</h1>
    <v-layout>
      <v-text-field v-model="name" solo label="Title"></v-text-field>
      <v-btn :disabled="(name != null && name != '') ? false : true" @click="createGoal" text
        color="success">add new ceremony</v-btn>
    </v-layout>
    <v-layout>
      <v-text-field @input="seatchMethod" v-model="search" solo label="Search"></v-text-field>
    </v-layout>
    <v-layout v-if="ceremonies != null">
      <v-data-table v-if="ceremonies.length" :headers="[
        /* { text: 'NUMBER', value: 'id_playlist' }, */
        { text: 'ID', value: 'id' },
        { text: 'NAME', value: 'name' },
        {text: 'INDEX ORDER', value: 'index_order'},
        { text: 'EDIT', value: 'edit' },
        { text: 'DELETE', value: 'actions' },


      ]" :items="filteredCeremonies">
        <template v-slot:item.actions="{ item }">
          <v-btn @click="deleteItem(item)" text color="error">DELETE</v-btn>
        </template>
        <template v-slot:item.edit="{ item }">
          <v-btn @click="edit(item)" text color="info">Edit</v-btn>
        </template>
      </v-data-table>
      <v-dialog v-model="dialog" v-if="selected != null" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>
            Updating
          </v-card-title>

          <v-card-text>
            <v-text-field v-model="selected.name" label="Title"></v-text-field>
          </v-card-text>

          <v-card-text>
            <v-text-field v-model="selected.index_order" label="Index order"></v-text-field>
          </v-card-text>

          <v-card-text>
            <img v-if="selected.preview!=null && selected.preview!=''" width="300px" height="180px" :src="selected.preview" style="margin-bottom: 20px;"/>
            <input v-show="false" ref="preview" type="file" accept=".png, .jpeg" @change="updatePreview">
            <v-btn style="margin: 5px;width: 200px;" small color="info" @click="$refs.preview.click()" :loading="loading.img">
            Upload preview / image
          </v-btn>
          <v-btn style="margin: 5px;width: 200px;" small color="error" @click="deleteImage">
            Delete preview / image
          </v-btn>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text>
            <video style="max-width: 300px !important; height: 180px; margin-bottom: 20px;" controls v-if="selected.video!=null && selected.video!=''" :src="selected.video"></video>
            <input v-show="false" ref="video" type="file" accept="video/*" @change="updateVideo">
            <v-btn style="margin: 5px;width: 200px;" small color="info" @click="$refs.video.click()" :loading="loading.video">
            Video upload
          </v-btn>
          <v-btn style="margin: 5px;width: 200px;" small color="error" @click="deleteVideo">
            Delete video
          </v-btn>
          </v-card-text>
          <v-divider></v-divider>


          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" flat @click="update">
              Update
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import Axios from 'axios';
import CryptoJS from "crypto-js";
import { Base64 } from 'js-base64';
export default {
  data() {
    return {
      name: null,
      ceremonies: null,
      filteredCeremonies: null,
      search: '',
      selected: null,
      dialog: false,
      loading:{
        img:false,
        video:false
      }
    }
  },
  methods: {
    deleteImage()
    {
      let obj = {
          id: this.selected.id
      }

            axios.post('/admin/ceremony/deleteImage', obj, {
              headers: {
                'Content-Type': 'application/json'
              }
            }).then(res => {
              this.selected.preview = res.data.data;
            });
    },
    deleteVideo()
    {
      let obj = {
          id: this.selected.id
      }

            axios.post('/admin/ceremony/deleteVideo', obj, {
              headers: {
                'Content-Type': 'application/json'
              }
            }).then(res => {
              this.selected.video = res.data.data;
            });
    },
    updatePreview(event) {
      this.loading.img = true;
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();
        reader.onload = () => {
            const base64Data = reader.result;
            let obj = {
                image: base64Data,
                id: this.selected.id
            }

            axios.post('/admin/ceremony/setImage', obj, {
              headers: {
                'Content-Type': 'application/json'
              }
            }).then(res => {
              this.selected.preview = res.data.data;
            }).finally(() => {
              this.loading.img = false;
            });
        };
        reader.readAsDataURL(file);
    },
    updateVideo(event) {
      var data = new FormData();
      this.loading.video = true;
      data.append('file', this.$refs.video.files[0]);
      axios.post('/admin/ceremony/' + this.selected.id + '/setVideo', data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        this.selected.video = res.data.data;
      }).finally(() => {
        this.loading.video = false;
      });
    },
    async update() {
      if (this.selected.name != null && this.selected.name != "")
        await axios
          .post("/admin/ceremony/update", {
            id: this.selected.id,
            name: this.selected.name,
            index_order: this.selected.index_order,
            preview: this.selected.preview,
            video: this.selected.video
          }).then(() => {
            
            this.sync();
            this.dialog = false;
          })
    },
    edit(item) {
      this.selected = Object.assign({}, item);
      this.dialog = true;
    },
    seatchMethod(val) {
      if (this.search == '') {
        this.filteredCeremonies = this.ceremonies.sort((a, b) => {
          const nameA = a.name.toUpperCase(); // Convert names to uppercase for case-insensitive sorting
          const nameB = b.name.toUpperCase();

          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0; // Names are equal
        });
        ;;
      }
      else {
        this.filteredCeremonies = this.ceremonies.filter(element => {
          return (element.name).includes(this.search)
        });
      }
    },
    async createGoal() {
      if (this.name != null && this.name != "")
        await axios
          .post("/admin/ceremony/create", {
            name: this.name
          }).then(() => {
            this.sync();
            this.name = null;
          })
    },
    async deleteItem(item) {
      await axios
        .post("/admin/ceremony/delete", item).then(() => {
          this.sync();
        })
    },
    async sync() {
      await axios
        .get("/admin/ceremony/get").then((res) => {
          this.ceremonies = res.data.sort((a, b) => {
            if (a.index_order === null && b.index_order !== null) {
              return 1; // Если у "a" index_order равен 0, а у "b" не равен 0, поместите "a" в конец
            } else if (a.index_order !== null && b.index_order === null) {
              return -1; // Если у "b" index_order равен 0, а у "a" не равен 0, поместите "b" в конец
            } else {
              return a.index_order - b.index_order; // Иначе сортируйте по index_order от меньшего к большему
            }
          });

          this.filteredCeremonies = res.data.sort((a, b) => {
            if (a.index_order === null && b.index_order !== null) {
              return 1; // Если у "a" index_order равен 0, а у "b" не равен 0, поместите "a" в конец
            } else if (a.index_order !== null && b.index_order === null) {
              return -1; // Если у "b" index_order равен 0, а у "a" не равен 0, поместите "b" в конец
            } else {
              return a.index_order - b.index_order; // Иначе сортируйте по index_order от меньшего к большему
            }
          });
        })
    },
  },
  created() {
    this.sync();
  }
}
</script>
<style lang="scss" scoped></style>